import React from 'react';
import { Body, Heading5 } from '~/components/atom/Typography';
import Icon from '~/components/atom/Icon';
import JustificationContainer from '~/components/atom/JustificationContainer';
import type { IconType } from '~/components/atom/Icon';

const SectionHeaderWithDescription: React.FCC<{
  icon: IconType;
  header: string;
  description: string;
}> = ({ icon, header, description }) => (
  <>
    <JustificationContainer
      direction="row"
      align="center"
      gap="xxs"
      margin={[null, null, 's']}
    >
      <Icon name={icon} strokeWidth={2.2} />
      <Heading5 size="base" margin={[null]}>
        {header}
      </Heading5>
    </JustificationContainer>
    <Body size="base">{description}</Body>
  </>
);

export default SectionHeaderWithDescription;
